const logoPaginaDofollow = 'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Sponsorship Expedientes del Delito',
    annualPrice: 'Consultar',
    monthlyPrice: 'Consultar',
    features: [
      'Menciones en vivo durante el programa',
      'Video comercial en bloque del programa',
      'Transmisión en vivo los miércoles a las 7:00 PM por TNO Network',
      'Presencia en Web, App y Redes Sociales',
      'Insert en clips de episodios publicados en redes (TNO Network, Angélica y Santiago)',
      'Asociación con autoridad periodística, justicia y seguridad',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan asociar su imagen con credibilidad, seguridad y responsabilidad social en un entorno de máximo prestigio periodístico.',
    duration: 'Consultar',
    buttonText: 'Patrocinar Expedientes del Delito',
    highlightedTitle: 'Autoridad y Confianza',
    highlightedContent: [
      'Tu marca junto a Santiago Gutiérrez y Angélica Lugo.',
      'Segmentos de análisis, menciones de autoridad y contenido con peso específico.',
      'Ideal para sectores que valoran la verdad y el respaldo editorial.',
    ],
    highlightedButtonText: 'Consultar Opciones',
  },
  {
    title: 'Segmento por Tema',
    annualPrice: 'Consultar',
    monthlyPrice: 'Consultar',
    features: [
      'Mención exclusiva: "Este segmento presentado por..."',
      'Vinculación con una temática: Análisis Criminal, Seguridad, DDHH, Ética y Sociedad',
      'Contenido alineado con el ADN de tu marca',
      'Presencia en el bloque correspondiente del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas especializadas en seguridad, legal, seguros o responsabilidad social que buscan relevancia temática.',
    duration: 'Consultar',
    buttonText: 'Elegir mi Tema',
    highlightedTitle: 'Relevancia Temática',
    highlightedContent: [
      'Tu marca como referente del segmento elegido.',
      'Asociación orgánica con justicia, seguridad y análisis verificado.',
    ],
    highlightedButtonText: 'Ver Temas Disponibles',
  },
  {
    title: 'Branded Content Editorial',
    annualPrice: 'Consultar',
    monthlyPrice: 'Consultar',
    features: [
      'Artículo o crónica en TNO Digest con enfoque de Expedientes del Delito',
      'Análisis de datos o reportaje con respaldo editorial',
      'Distribución en el ecosistema TNO y redes del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan profundidad y credibilidad a través del contenido editorial verificado.',
    duration: 'Por pieza',
    buttonText: 'Solicitar Branded Content',
    highlightedTitle: 'Contenido con Peso Específico',
    highlightedContent: [
      'Tu marca en formato crónica de autor y análisis.',
      'Máxima transferencia de credibilidad y seriedad periodística.',
    ],
    highlightedButtonText: 'Enviar mi Propuesta',
  },
  {
    title: 'Insert en clips',
    annualPrice: 'Consultar',
    monthlyPrice: 'Consultar',
    features: [
      'Insert publicitario en los clips de los episodios que se publican en redes',
      'Clips distribuidos en redes de TNO Network, Angélica Lugo y Santiago Gutiérrez',
      'Alcance orgánico y contenido nativo con el programa',
      'Ideal para reforzar mensaje o campaña con el respaldo de Expedientes del Delito',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan visibilidad en el contenido corto y viral del programa en todas las redes.',
    duration: 'Consultar',
    buttonText: 'Consultar Insert en Clips',
    highlightedTitle: 'Clips en todas las redes',
    highlightedContent: [
      'Los episodios se resumen en clips que se publican en TNO Network, Angélica y Santiago.',
      'Tu marca puede insertarse en esos clips con máximo alcance y credibilidad.',
    ],
    highlightedButtonText: 'Ver Opciones de Clips',
  },
  {
    title: 'Redes sociales de los hosts',
    annualPrice: 'Consultar',
    monthlyPrice: 'Consultar',
    features: [
      'Presencia en las redes de Santiago Gutiérrez y Angélica Lugo',
      'Alcance combinado: más de 935K seguidores (Instagram, TikTok, X)',
      'Stories, Reels, TikTok o publicaciones según paquete',
      'Contenido auténtico con la voz y credibilidad de los anclas',
      'Ideal para campañas de awareness o lanzamientos con máximo alcance',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que quieren llegar a la audiencia directa de los hosts en sus redes, con contenido nativo y alta credibilidad.',
    duration: 'Consultar',
    buttonText: 'Consultar Redes de los Hosts',
    highlightedTitle: 'Alcance directo de los anclas',
    highlightedContent: [
      'Santiago y Angélica suman más de 935K seguidores en Instagram, TikTok y X.',
      'Tu marca en el feed y stories de quienes lideran Expedientes del Delito.',
    ],
    highlightedButtonText: 'Ver Opciones de Redes',
  },
];

export default optionsData;
